import { FC, useEffect } from "react";
import { useForm } from "react-hook-form";

// Utilities
import { useDebounce } from "@/_helpers/hooks";

// Components
import { Box } from "@mui/material";
import Tag, { TagProps } from "@/components/tag";
import SearchInput from "@/components/search_input";
import FilterBar, { FilterBarProps } from "./filter_bar";


interface _HeaderProps {
    filters: FilterBarProps;
    tags?: TagProps[];
    onSearchChange?: (search: string) => void;
}

const Header: FC<_HeaderProps> = ({
    filters,
    tags,
    onSearchChange
}) => {

    const { control, watch } = useForm({defaultValues: {search: ''}})
    const search = watch('search');
    const debouncedVal = useDebounce(search, 500);

    useEffect(() => {
        onSearchChange && onSearchChange(debouncedVal);
    }, [debouncedVal, onSearchChange]);

    return (
        <Box display="flex" padding="0px 0px 24px 0px" alignItems="center">

            <SearchInput name="search" control={control} />

            {/* Spacing */}
            <Box width="16px" />

            {tags?.map(tag => (
                <Tag key={tag.label} {...tag} sx={{ marginRight: '8px' }} />
            ))}

            {/* Spacing */}
            <Box flexGrow={1} />

            <FilterBar 
                filterItems={filters.filterItems}
                filters={filters.filters}
                setFilter={filters.setFilter}
                resetFilters={filters.resetFilters}
                />

        </Box>
    )
}

export default Header;